const TimeRemaining = (interval) => {
    let secondsRemaining = 0;
    if (Number(interval)) {
        secondsRemaining = interval - (Math.floor(Date.now() / 1000) % interval);
    }
    return secondsRemaining

}
export default TimeRemaining;